<template>
    <admin-layout>

        <app-content-pane class="ml-3">

            <template #title>
                <div class="top">
                    <div class="px-4 pt-3">
                        <h1>Users</h1>
                        <nav>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">Users</li>
                            </ol>
                        </nav>
                    </div>
                    <div class="actions px-4 pt-3">
                        <div class="form-group mr-2">
                            <form :action="route('usr.export', {...global_url_params, ...$page.props.query})" method="post">
                                <input type="hidden" name="_token" :value="$page.props.csrf_token">
                                <button class="btn btn-success d-flex align-items-center justify-content-center"
                                        method="post">Export</button>
                            </form>
                        </div>
                        <div class="form-group">
                            <inertia-link :href="route('usr.create', {...global_url_params})"
                                          class="btn btn-primary d-flex align-items-center justify-content-center">
                                <img src="/images/icons/plus-circle-solid-light.svg" class="mr-2" alt="">
                                Create New User
                            </inertia-link>
                        </div>
                    </div>
                </div>

            </template>

            <div class="users">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th colspan="2">
                            <input type="text" class="form-control" placeholder="search" v-model="filters.q">
                        </th>
                        <th>
                            <select class="form-control" v-model="filters.type">
                                <option value="">All Users</option>
                                <option value="admin">Admin</option>
                                <option value="teacher">Teacher</option>
                            </select>
                        </th>
                        <th>Projects</th>
                        <th>Email</th>
                        <th>
                            <!-- Organization(s) -->
                            <organization-selector @ready="is_ready = true"
                                                   @change="setOrganization($event)"/>
                        </th>
                        <th>Other Info</th>
                        <th>Registered On</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in users" :key="user.id">
                        <td style="width: 40px"><name-icon :value="user"></name-icon></td>
                        <td>
                            <div class="font-weight-bold h6">
                                {{ user.name }}
                                <span class="badge" :class="badge(user)?.class">
                                    {{ badge(user)?.label }}
                                </span>
                                <span v-if="userIsSelf(user)" class="badge badge-danger">Me</span>
                            </div>
                            <div class="actions">

                                <template v-if="! userIsSelf(user)">
                                    <inertia-link :href="route('usr.edit', {usr: user.id, ...global_url_params})"
                                                  class="btn btn-link btn-sm px-1">Edit</inertia-link>
                                </template>

                                <template v-if="! userIsSelf(user)">
                                    <button @click="deleteUser(user)"
                                            class="btn btn-link btn-sm text-danger px-1">Delete</button>
                                    <template v-if="is_admin">
                                        <inertia-link :href="route('auth.impersonate', {user: user.id, ...global_url_params})"
                                                      class="btn btn-link btn-sm text-do px-1"
                                                      method="post">Impersonate</inertia-link>
                                    </template>
                                </template>
                            </div>
                        </td>
                        <td>{{ user.type }}</td>
                        <td>
                            <inertia-link :href="route('project.index', {created_by_id: user.id, ...global_url_params})"
                                          title="View Projects"
                                          class="btn btn-link btn-sm text-success px-1">{{ user.project_count }}</inertia-link>
                        </td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.organizations.map(o => o.name).join(', ') }}</td>
                        <td><repeat-info :values="user.meta" only="number_of_students,referred_by" /></td>
                        <td>{{ dateFormat( user.created_at ) }}</td>
                    </tr>
                    </tbody>
                    <caption v-if="!users.length" class="px-3">
                        <div class="alert alert-danger mb-0 mt-5">
                            Sorry no users found. Please try with different search criteria.
                        </div>
                    </caption>
                </table>

                <div class="mx-3 mt-3 pb-4">
                    <pagination :links="usersPaginated.links"></pagination>
                </div>

            </div>
        </app-content-pane>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import Pagination from "@/Components/Common/Pagination";
import NameIcon from "@/Components/Team/NameIcon";
import RepeatInfo from "@/Components/Common/RepeatInfo";
import OrganizationSelector from "@/Components/Common/OrganizationSelector";
import Input from "@/Jetstream/Input.vue";
export default {
    name: "Index",
    components: {Input, OrganizationSelector, RepeatInfo, NameIcon, Pagination, AppContentPane, AdminLayout},
    props: ['usersPaginated', 'pageFilters'],

    data(){
        return {
            is_ready: false,

            refreshDebounced: _.debounce(() => this.refresh(1), 500),
            filters: {
                q: '',
                type: '',
                organization_id: null,
            }
        }
    },

    computed: {
        users(){
            return this.usersPaginated.data;
        },
    },

    watch: {
        filters: {
            deep: true,
            handler(val){
                // console.log({handler: JSON.stringify(val), is_ready: this.is_ready});
                if( !this.is_ready ) return;
                this.refreshDebounced();
            }
        }
    },


    methods: {

        badge(user){
            if( user.derived_account_type === 'free' ){
                return {class: 'badge-dark', label: 'free'};
            }

            if( user.account_type === 'paid' ){
                if( ! user.trial_expire_at ){
                    return {class: 'badge-primary', label: 'paid'};
                }
            }

            if( user.organizations?.length ){
                const org = user.organizations[0];
                if( org.account_type === 'paid' ){
                    if( org.trial_expire_at ){
                        if( user.trial_expires_in === null || org.trial_expires_in > user.trial_expires_in ){
                            if( org.trial_expires_in >= 0 ){
                                return {class: 'badge-warning', label: `org:trial (${org.trial_expires_in} day${org.trial_expires_in > 1 ? 's' : ''})`};
                            }
                            return {class: 'badge-danger', label: `org:trial:expired`};
                        }
                    }else{
                        return {class: 'badge-primary', label: `org:paid`};
                    }
                }
            }


            if( user.trial_expire_at && user.account_type !== 'paid'){
                if( user.trial_expires_in >= 0 ){
                    return {class: 'badge-warning', label: `trial (${user.trial_expires_in} day${user.trial_expires_in > 1 ? 's' : ''})`};
                }
                return {class: 'badge-danger', label: `trial:expired`};
            }

        },

        refresh(page = false){
            // console.log('called');
            this.$inertia.reload({data: {...this.filters, page: page ? page : this.usersPaginated.current_page}});
        },

        async deleteUser(user){
            if( !confirm('Are you sure to delete user ' + user.name + '?') ) return;
            await axios.delete(this.route('usr.destroy', {usr: user.id,...this.global_url_params}));
            this.refresh();
        },

        dateFormat(date_str){
            const d = new Date(date_str);
            return d.toLocaleString('en-US');
        },

        userIsSelf(user){
            return user.id === this.$page.props.user.id
        },

        setOrganization(org){
            if( ! this.is_ready ) return;
            this.filters.organization_id = org?.id ?? null;
        }
    },

    beforeMount() {
        this.filters.q = this.pageFilters.q;
        this.filters.type = this.pageFilters.type;
        this.filters.organization_id = this.pageFilters.organization_id ?? null;
    },

    mounted() {
        this.setTitle( 'Users' );
    }

}
</script>

<style lang="scss" scoped>

.top{
    display: flex;
    align-items: center;

    .actions{
        margin-left: auto;
        display: flex;
    }
}

.users{
    .actions{
        opacity: 0;
        transition: opacity .3s;
    }

    tr:hover{
        .actions{
            opacity: 1;
        }
    }
}

</style>
